/* eslint-disable max-len */
export const subscriptionFeatures = [
  {
    description: bfTranslate('Sharing and tracking of distributed assets'),
    id: 'share-links',
    name: bfTranslate('Share Links'),

  },
  {
    description: bfTranslate('Extract and view file metadata'),
    id: 'metadata',
    name: bfTranslate('Metadata'),

  },
  {
    description: bfTranslate('Transform, transcode, resize, and preview videos'),
    id: 'advanced-video',
    name: bfTranslate('Advanced Video'),

  },
  {
    description: bfTranslate('Get embed codes for your assets and power web and mobile experiences'),
    id: 'embed-assets',
    name: bfTranslate('Embed Assets/CDN'),

  },
  {
    description: bfTranslate('Track custom fields and values, such as product data'),
    id: 'custom-fields',
    name: bfTranslate('Custom Fields'),

  },
  {
    description: bfTranslate('View asset usage data such as views, downloads, search terms, and shares'),
    id: 'insights',
    name: bfTranslate('Insights'),

  },
  {
    description: bfTranslate('Allow assets to be approved before being published'),
    id: 'approvals',
    name: bfTranslate('Approvals'),

  },
  {
    description: bfTranslate('Allow assets to be approved before being published'),
    id: 'advanced-approvals',
    name: bfTranslate('Advanced Approvals'),

  },
  {
    description: bfTranslate('Set publish and expiration dates for assets'),
    id: 'availability',
    name: bfTranslate('Availability'),

  },
  {
    description: bfTranslate('Create asset request links for requesting files from guest users'),
    id: 'guest-upload',
    name: bfTranslate('Guest Upload'),

  },
  {
    description: bfTranslate('In-document search and text extraction (PDF and Office)'),
    id: 'document-search',
    name: bfTranslate('Document Search'),

  },
  {
    description: bfTranslate('Large centered watermark applied in the asset modal over attachment'),
    id: 'legacy-watermarking',
    name: bfTranslate('Legacy Watermarking'),

  },
  {
    description: bfTranslate('Rule-based or asset modal applied small watermark in a corner of the asset (png, jpg, and jpeg only)'),
    id: 'watermarking',
    name: bfTranslate('Watermarking'),

  },
  {
    description: bfTranslate('Create and customize online brand guides'),
    id: 'brandguide',
    name: bfTranslate('Brandguide'),

  },
  {
    description: bfTranslate('Identity management integration with SAML/SSO providers and team mappings'),
    id: 'saml-sso',
    name: bfTranslate('SAML/SSO'),

  },
  {
    description: bfTranslate('Import designed templates and allow users to edit content'),
    id: 'templates',
    name: bfTranslate('Templates'),

  },
  {
    description: bfTranslate('Don\'t see a feature you\'re looking for? Talk to your representative for more information'),
    id: 'other',
    name: bfTranslate('Other'),
  }
];
